module.exports = __webpack_public_path__ + "img/forward.4acef95a.svg";